
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const HebrewFAQSection = () => {
  return (
    <div className="mb-10">
      <h2 className="text-2xl font-semibold mb-6 text-blue-700">שאלות נפוצות</h2>
      
      <Accordion type="single" collapsible className="bg-white rounded-lg shadow-sm border border-blue-100 mb-6">
        <AccordionItem value="item-1">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            כמה זמן לוקח לקבל החלטה על הלוואה?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            באמצעות השירות שלנו, בדרך כלל תקבל הצעות ממספר בנקים תוך 24 שעות. 
            חלק מהמלווים עשויים לספק החלטה מקדימה מיידית. זמן האישור הסופי תלוי 
            בסוג ההלוואה ובסכום.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-2">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            האם הגשת בקשה דרך Lainasampo תשפיע על דירוג האשראי שלי?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            כאשר אתה מגיש בקשה דרך Lainasampo, מתבצעת בדיקת אשראי. בפינלנד, בדיקה זו 
            נרשמת על ידי Suomen Asiakastieto, אך בקשות מרובות דרך השירות שלנו במהלך 
            אותה תקופה נספרות כבדיקה אחת למטרות ניקוד.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-3">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            מהו הסכום המינימלי והמקסימלי של הלוואה זמינה?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            סכומי ההלוואה משתנים לפי המלווה וסוג ההלוואה. הלוואות צרכניות נעות בדרך כלל 
            בין 1,000 € ל-60,000 €, בעוד שמשכנתאות יכולות להגיע למאות אלפי אירו. 
            הסכומים הספציפיים הזמינים עבורך תלויים בהכנסה שלך והיסטוריית האשראי שלך.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-4">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            האם אני יכול להגיש בקשה אם אינני אזרח פיני?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            כן, אבל בדרך כלל אתה צריך מספר זהות פיני (henkilötunnus) ותושבות קבע בפינלנד. 
            חלק מהמלווים עשויים גם לדרוש שחיית בפינלנד לתקופה מינימלית (בדרך כלל 1-2 שנים) 
            ושיש לך היסטוריית הכנסות יציבה בפינלנד.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-5">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            כיצד נקבעים שיעורי הריבית?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            שיעורי הריבית נקבעים על בסיס המצב הפיננסי האישי שלך, סכום ההלוואה, תקופת 
            ההלוואה ותנאי השוק הנוכחיים. דירוג האשראי שלך, רמת ההכנסה ומצב התעסוקה 
            כולם משחקים תפקיד בשיעור הריבית שמוצע לך.
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      
      <div className="text-center">
        <Link 
          to="/hebrew/apply" 
          className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded shadow-md transition-colors font-medium"
        >
          הגש בקשה להלוואה עכשיו
          <ArrowRight className="mr-2 h-5 w-5 transform rotate-180" />
        </Link>
      </div>
    </div>
  );
};
